// @ts-ignore
import React, { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useParams } from "react-router-dom";
import { currentDomain, getCaptchaSitekeyForSignup } from "../../Util/general-config";

let domain: string = currentDomain();
const RECAPTCHA_SITE_KEY = getCaptchaSitekeyForSignup();
interface GoogleCaptchaProps {
  onCaptchaSuccess: (token: string) => void;
}
const GoogleCaptcha: React.FC<GoogleCaptchaProps> = ({ onCaptchaSuccess }) => {
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const { locale } = useParams();
  const handleChange = (token: string | null) => {
    if (!token) return;
    console.log("Captcha success, token:", token);
    onCaptchaSuccess(token);
  };

  return (
    <div>
      <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} ref={recaptchaRef} theme="light" onChange={handleChange} hl={locale} />
    </div>
  );
};

export default GoogleCaptcha;
